var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 904,
    height: 1024,
    viewBox: "0 0 904 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 60.2353,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    d: "M663.811 686.363l50.899-50.345c0.018-0.018 0.042-0.036 0.060-0.060 48.188-48.211 81.004-109.627 94.298-176.484 13.3-66.885 6.475-136.212-19.625-199.215s-70.295-116.853-126.994-154.739c-56.706-37.887-123.367-58.108-191.561-58.108s-134.858 20.222-191.56 58.108c-56.702 37.886-100.897 91.736-126.995 154.739s-32.928 132.33-19.626 199.215c13.302 66.884 46.139 128.322 94.358 176.544 12.647 12.649 28.363 28.19 47.206 46.694 0.016 0.012 0.033 0.030 0.049 0.048l150.157 146.071c0.011 0.012 0.023 0.018 0.034 0.030 12.447 12.017 29.073 18.733 46.376 18.733 17.318 0 33.959-6.728 46.409-18.763l146.514-142.469zM663.811 686.363c-0.018 0.018-0.036 0.030-0.054 0.048M663.811 686.363l-0.054 0.048M663.757 686.411c-37.599 36.87-86.403 84.341-146.458 142.42l146.458-142.42zM608.654 404.038c0-36.538-14.513-71.58-40.349-97.416s-60.878-40.351-97.416-40.351c-36.538 0-71.579 14.515-97.416 40.351s-40.351 60.878-40.351 97.416c0 36.538 14.515 71.579 40.351 97.416s60.878 40.351 97.416 40.351c36.538 0 71.58-14.515 97.416-40.351s40.349-60.878 40.349-97.416z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 60.2353,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M686.188 774.355h51.67l120.573 206.685h-775.078l120.567-206.685h47.366"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegion);
export default __webpack_public_path__ + "static/media/icon-region.ef77a23559d45312638c0864c2b8b139.svg";
export { ForwardRef as ReactComponent };